// extracted by mini-css-extract-plugin
export default {"b-icon-warning":"Privacy_style_b-icon-warning__w-86p","wrapper":"Privacy_style_wrapper__W0Zod","content":"Privacy_style_content__mFnH8","rotate":"Privacy_style_rotate__4nzLR"};